import { createSelector, createFeatureSelector } from '@ngrx/store';

import { SoilTypeState, SoilType } from '../soil-type.model';

export const selectSoilTypeState = createFeatureSelector<SoilTypeState>('soil-type');

export const selectSoilTypes = createSelector(
  selectSoilTypeState,
  (state) => state.soilTypes || [],
);

export const selectSoilType = createSelector(
  selectSoilTypes,
  (soilTypes: SoilType[], soilTypeId: number) =>
    soilTypes.find((soilType) => soilType.id === soilTypeId),
);
